import '@babel/polyfill';

window.onload = () => {
  if (!window.dpwsToolLoaderIsLoaded) {
    /* eslint-disable */
    const toolsList = require('./commonConstants/toolsList');
    /* eslint-enable */

    let IsReactImported = false;
    let React = false;
    let ReactDOM = false;

    /* eslint-disable */
    const importReact = () => {
      if (IsReactImported) {
        return;
      }
      React = require('react');
      ReactDOM = require('react-dom');
      IsReactImported = true;
    };
    /* eslint-enable */

    const renderTool = (Tool, toolWrapper) => {
      ReactDOM.render(
        <React.Suspense fallback={<div>Loading...</div>}>
          <Tool />
        </React.Suspense>,
        toolWrapper,
      );
    };

    toolsList.forEach((toolName) => {
      const toolsWrapperList = Array.from(
        document.querySelectorAll(`.${toolName}`),
      );
      if (toolsWrapperList.length > 0) {
        importReact();
        const Tool = React.lazy(() => import(`./tools/${toolName}`));
        toolsWrapperList.forEach(toolWrapper => renderTool(Tool, toolWrapper));
      }
      return false;
    });

    window.dpwsToolLoaderIsLoaded = true;
  }
};
